import styles from "./landing.module.css";
import AnnonLanding from "./annon_landing/annon_landing";
import {useAuth} from "../../context/AppAuthContext";
import UserLanding from "./user_landing/user_landing";


export default function LandingPage() {
    const {isAuthenticated} = useAuth();

    return (
        <>
            {!isAuthenticated ? <AnnonLanding/> : <UserLanding/>}
        </>
    )
}